// SPDX-License-Identifier: AGPL-3.0-or-later
// Generated by packages/fluxer-theme/sync.py from racing.json. Do not edit.

export const RACING_THEME_VALUES: Readonly<Record<string, Readonly<Record<string, string>>>> = {
	"dark": {
		"--background-primary": "#1B1A19",
		"--background-secondary": "#151515",
		"--background-secondary-alt": "#201E1C",
		"--background-secondary-lighter": "#252321",
		"--background-tertiary": "#101010",
		"--background-textarea": "#252321",
		"--background-channel-header": "#1B1A19",
		"--background-header-primary": "#201E1C",
		"--background-header-primary-hover": "#35302B",
		"--background-header-secondary": "#201E1C",
		"--background-floating": "#252321",
		"--guild-list-foreground": "#151515",
		"--background-modifier-hover": "#35302B",
		"--background-modifier-selected": "#45301E",
		"--background-modifier-accent": "var(--background-modifier-hover)",
		"--background-modifier-accent-focus": "#FFAD63",
		"--text-primary": "#F5F1ED",
		"--text-chat": "#F5F1ED",
		"--text-secondary": "#C8BAB0",
		"--text-tertiary": "#B5A79C",
		"--text-tertiary-muted": "#A99B90",
		"--text-tertiary-secondary": "#A99B90",
		"--text-primary-muted": "#C8BAB0",
		"--text-chat-muted": "#B5A79C",
		"--brand-primary": "#FFAD63",
		"--brand-secondary": "#F6A05B",
		"--brand-primary-light": "#FFD1A7",
		"--brand-primary-foreground": "#FFAD63",
		"--brand-primary-fill": "#231407",
		"--brand-primary-light-fill": "#231407",
		"--brand-primary-shade": "#D58943",
		"--brand-tint": "#45301E",
		"--brand-tint-hover": "#563A23",
		"--brand-tint-border": "#C8894D",
		"--border-color": "#443D36",
		"--border-color-hover": "#867464",
		"--status-online": "#66D5A0",
		"--status-idle": "#E6C15A",
		"--status-dnd": "#FF9B9B",
		"--status-offline": "#A99B90",
		"--status-danger": "#FF9B9B",
		"--accent-info": "#8DCBF0",
		"--accent-purple": "#C6ABF0",
		"--button-danger-fill": "#B93048",
		"--button-danger-active-fill": "#9E263B",
		"--button-danger-text": "#FFFFFF",
		"--button-danger-outline-text": "#FF9B9B",
		"--button-danger-outline-active-fill": "#512830",
		"--panel-control-bg": "#201E1C",
		"--panel-control-border": "#61544A",
		"--panel-control-divider": "#443D36",
		"--panel-control-highlight": "#443D36",
		"--control-button-danger-hover-bg": "#512830",
		"--scrollbar-thumb-bg": "#78685A",
		"--scrollbar-thumb-bg-hover": "#A99B90",
		"--scrollbar-track-bg": "#151515",
		"--switch-track-inactive": "var(--border-color-hover)",
		"--switch-thumb": "#F5F1ED",
		"--switch-thumb-checked-icon": "var(--brand-primary)",
		"--switch-thumb-unchecked-icon": "#252321",
		"--button-inverted-fill": "#F5F1ED",
		"--button-inverted-text": "#1B1A19",
		"--text-on-dark": "#F5F1ED",
		"--brand-primary-pressed": "var(--brand-secondary)",
		"--text-on-brand-primary": "var(--brand-primary-fill)",
		"--text-on-brand-primary-light": "var(--brand-primary-light-fill)",
		"--text-on-brand-tint": "var(--brand-primary-foreground)",
		"--text-link": "var(--brand-primary-foreground)",
		"--border-color-focus": "var(--brand-primary-foreground)",
		"--focus-primary": "var(--brand-primary-foreground)",
		"--text-warning": "var(--status-idle)",
		"--text-danger": "var(--status-danger)",
		"--text-positive": "var(--status-online)",
		"--status-warning": "var(--status-idle)",
		"--accent-primary": "var(--brand-primary)",
		"--accent-success": "var(--status-online)",
		"--accent-warning": "var(--status-idle)",
		"--accent-danger": "var(--status-danger)",
		"--button-primary-fill": "var(--brand-primary)",
		"--button-primary-active-fill": "var(--brand-primary-pressed)",
		"--button-primary-text": "var(--text-on-brand-primary)",
		"--button-secondary-fill": "var(--background-secondary-alt)",
		"--button-secondary-active-fill": "var(--background-modifier-hover)",
		"--button-secondary-text": "var(--text-primary)",
		"--button-secondary-active-text": "var(--text-primary)",
		"--button-ghost-text": "var(--text-secondary)",
		"--button-outline-text": "var(--text-primary)",
		"--button-outline-active-fill": "var(--background-modifier-hover)",
		"--control-button-normal-bg": "var(--background-secondary-alt)",
		"--control-button-normal-text": "var(--text-secondary)",
		"--control-button-hover-bg": "var(--background-modifier-hover)",
		"--control-button-hover-text": "var(--text-primary)",
		"--control-button-active-bg": "var(--brand-tint)",
		"--control-button-active-text": "var(--text-on-brand-tint)",
		"--control-button-danger-text": "var(--status-danger)",
		"--interactive-normal": "var(--text-secondary)",
		"--interactive-hover": "var(--text-primary)",
		"--interactive-active": "var(--text-primary)",
		"--interactive-muted": "var(--text-tertiary-muted)",
		"--markup-mention-text": "var(--brand-primary-foreground)",
		"--markup-mention-fill": "var(--brand-tint)",
		"--markup-mention-border": "var(--brand-tint-border)",
		"--markup-interactive-hover-text": "var(--brand-primary-foreground)",
		"--markup-interactive-hover-fill": "var(--brand-tint-hover)",
		"--markup-jump-link-text": "var(--brand-primary-foreground)",
		"--markup-jump-link-fill": "var(--brand-tint)",
		"--markup-jump-link-hover-fill": "var(--brand-tint-hover)",
		"--alert-note-color": "var(--accent-info)",
		"--alert-tip-color": "var(--status-online)",
		"--alert-important-color": "var(--accent-purple)",
		"--alert-warning-color": "var(--status-idle)",
		"--alert-caution-color": "var(--status-danger)",
		"--bg-primary": "var(--background-primary)",
		"--bg-secondary": "var(--background-secondary)",
		"--bg-tertiary": "var(--background-tertiary)",
		"--bg-hover": "var(--background-modifier-hover)",
		"--bg-active": "var(--background-modifier-selected)",
		"--bg-table-header": "var(--background-tertiary)",
		"--bg-table-row-odd": "var(--background-primary)",
		"--bg-table-row-even": "var(--background-secondary)",
		"--surface-interactive-hover-bg": "var(--background-modifier-hover)",
		"--surface-interactive-selected-bg": "var(--background-modifier-selected)",
		"--surface-interactive-selected-color": "var(--text-primary)",
		"--embed-background": "var(--background-secondary)",
		"--embed-border": "var(--border-color)",
		"--chat-background": "var(--background-primary)",
		"--chat-input-background": "var(--background-textarea)",
		"--server-sidebar-background": "var(--background-tertiary)",
		"--server-icon-background": "var(--background-secondary-alt)",
		"--server-icon-active": "var(--brand-primary)",
		"--channel-sidebar-background": "var(--background-secondary)",
		"--member-list-background": "var(--background-secondary)",
		"--user-panel-background": "var(--background-secondary-alt)",
		"--user-area-divider-color": "var(--border-color)",
		"--mention-background": "var(--brand-tint)",
		"--menu-danger-text": "var(--status-danger)",
		"--button-outline-border": "1px solid var(--border-color-hover)",
		"--button-outline-active-border": "1px solid var(--border-color-focus)",
		"--button-danger-outline-border": "1px solid var(--status-danger)",
		"--button-danger-outline-active-border": "1px solid var(--status-danger)",
		"--text-selection": "color-mix(in srgb, var(--brand-primary-foreground) 28%, transparent)",
		"--bg-code": "var(--background-secondary-alt)",
		"--bg-code-block": "var(--background-tertiary)",
		"--code-inline-bg": "var(--background-secondary-alt)",
		"--code-block-bg": "var(--background-tertiary)",
		"--code-block-border": "var(--border-color)",
		"--guild-banner-gradient": "var(--background-tertiary)",
		"--text-on-danger": "#231407",
		"--text-on-success": "#231407",
		"--text-on-light": "#29231E",
		"--profile-banner-background": "var(--background-secondary-alt)",
		"--profile-card-border": "var(--border-color)",
		"--voice-placeholder-background": "#1B1A19"
	},
	"light": {
		"--background-primary": "#FFFDFC",
		"--background-secondary": "#F3EFEB",
		"--background-secondary-alt": "#EAE3DD",
		"--background-secondary-lighter": "#F8F4F0",
		"--background-tertiary": "#E8E0D9",
		"--background-textarea": "#F3EFEB",
		"--background-channel-header": "#FFFDFC",
		"--background-header-primary": "#F3EFEB",
		"--background-header-primary-hover": "#E6DDD5",
		"--background-header-secondary": "#F3EFEB",
		"--background-floating": "#FFFDFC",
		"--guild-list-foreground": "#E8E0D9",
		"--background-modifier-hover": "#EAE3DD",
		"--background-modifier-selected": "#F6DFC9",
		"--background-modifier-accent": "var(--background-modifier-hover)",
		"--background-modifier-accent-focus": "#9B470F",
		"--text-primary": "#29231E",
		"--text-chat": "#29231E",
		"--text-secondary": "#574A3F",
		"--text-tertiary": "#6A5B4E",
		"--text-tertiary-muted": "#6A5B4E",
		"--text-tertiary-secondary": "#6A5B4E",
		"--text-primary-muted": "#574A3F",
		"--text-chat-muted": "#6A5B4E",
		"--brand-primary": "#9B470F",
		"--brand-secondary": "#823B0C",
		"--brand-primary-light": "#823B0C",
		"--brand-primary-foreground": "#9B470F",
		"--brand-primary-fill": "#FFFFFF",
		"--brand-primary-light-fill": "#FFFFFF",
		"--brand-primary-shade": "#642B08",
		"--brand-tint": "#F6DFC9",
		"--brand-tint-hover": "#F1D8BF",
		"--brand-tint-border": "#A75A25",
		"--border-color": "#C8BBAF",
		"--border-color-hover": "#8F7C6C",
		"--status-online": "#237548",
		"--status-idle": "#765700",
		"--status-dnd": "#AD2941",
		"--status-offline": "#6A5B4E",
		"--status-danger": "#AD2941",
		"--accent-info": "#225F88",
		"--accent-purple": "#705095",
		"--button-danger-fill": "#AD2941",
		"--button-danger-active-fill": "#902037",
		"--button-danger-text": "#FFFFFF",
		"--button-danger-outline-text": "#AD2941",
		"--button-danger-outline-active-fill": "#F9E1E5",
		"--panel-control-bg": "#F3EFEB",
		"--panel-control-border": "#A8998C",
		"--panel-control-divider": "#C8BBAF",
		"--panel-control-highlight": "#FFFDFC",
		"--control-button-danger-hover-bg": "#F9E1E5",
		"--scrollbar-thumb-bg": "#8F7C6C",
		"--scrollbar-thumb-bg-hover": "#574A3F",
		"--scrollbar-track-bg": "#F3EFEB",
		"--switch-track-inactive": "var(--border-color-hover)",
		"--switch-thumb": "#FFFFFF",
		"--switch-thumb-checked-icon": "var(--brand-primary)",
		"--switch-thumb-unchecked-icon": "#574A3F",
		"--button-inverted-fill": "#29231E",
		"--button-inverted-text": "#FFFDFC",
		"--text-on-dark": "#F5F1ED",
		"--brand-primary-pressed": "var(--brand-secondary)",
		"--text-on-brand-primary": "var(--brand-primary-fill)",
		"--text-on-brand-primary-light": "var(--brand-primary-light-fill)",
		"--text-on-brand-tint": "var(--brand-secondary)",
		"--text-link": "var(--brand-primary-foreground)",
		"--border-color-focus": "var(--brand-primary-foreground)",
		"--focus-primary": "var(--brand-primary-foreground)",
		"--text-warning": "var(--status-idle)",
		"--text-danger": "var(--status-danger)",
		"--text-positive": "var(--status-online)",
		"--status-warning": "var(--status-idle)",
		"--accent-primary": "var(--brand-primary)",
		"--accent-success": "var(--status-online)",
		"--accent-warning": "var(--status-idle)",
		"--accent-danger": "var(--status-danger)",
		"--button-primary-fill": "var(--brand-primary)",
		"--button-primary-active-fill": "var(--brand-primary-pressed)",
		"--button-primary-text": "var(--text-on-brand-primary)",
		"--button-secondary-fill": "var(--background-secondary-alt)",
		"--button-secondary-active-fill": "var(--background-modifier-hover)",
		"--button-secondary-text": "var(--text-primary)",
		"--button-secondary-active-text": "var(--text-primary)",
		"--button-ghost-text": "var(--text-secondary)",
		"--button-outline-text": "var(--text-primary)",
		"--button-outline-active-fill": "var(--background-modifier-hover)",
		"--control-button-normal-bg": "var(--background-secondary-alt)",
		"--control-button-normal-text": "var(--text-secondary)",
		"--control-button-hover-bg": "var(--background-modifier-hover)",
		"--control-button-hover-text": "var(--text-primary)",
		"--control-button-active-bg": "var(--brand-tint)",
		"--control-button-active-text": "var(--text-on-brand-tint)",
		"--control-button-danger-text": "var(--status-danger)",
		"--interactive-normal": "var(--text-secondary)",
		"--interactive-hover": "var(--text-primary)",
		"--interactive-active": "var(--text-primary)",
		"--interactive-muted": "var(--text-tertiary-muted)",
		"--markup-mention-text": "var(--brand-primary-foreground)",
		"--markup-mention-fill": "var(--brand-tint)",
		"--markup-mention-border": "var(--brand-tint-border)",
		"--markup-interactive-hover-text": "var(--brand-primary-foreground)",
		"--markup-interactive-hover-fill": "var(--brand-tint-hover)",
		"--markup-jump-link-text": "var(--brand-primary-foreground)",
		"--markup-jump-link-fill": "var(--brand-tint)",
		"--markup-jump-link-hover-fill": "var(--brand-tint-hover)",
		"--alert-note-color": "var(--accent-info)",
		"--alert-tip-color": "var(--status-online)",
		"--alert-important-color": "var(--accent-purple)",
		"--alert-warning-color": "var(--status-idle)",
		"--alert-caution-color": "var(--status-danger)",
		"--bg-primary": "var(--background-primary)",
		"--bg-secondary": "var(--background-secondary)",
		"--bg-tertiary": "var(--background-tertiary)",
		"--bg-hover": "var(--background-modifier-hover)",
		"--bg-active": "var(--background-modifier-selected)",
		"--bg-table-header": "var(--background-tertiary)",
		"--bg-table-row-odd": "var(--background-primary)",
		"--bg-table-row-even": "var(--background-secondary)",
		"--surface-interactive-hover-bg": "var(--background-modifier-hover)",
		"--surface-interactive-selected-bg": "var(--background-modifier-selected)",
		"--surface-interactive-selected-color": "var(--text-primary)",
		"--embed-background": "var(--background-secondary)",
		"--embed-border": "var(--border-color)",
		"--chat-background": "var(--background-primary)",
		"--chat-input-background": "var(--background-textarea)",
		"--server-sidebar-background": "var(--background-tertiary)",
		"--server-icon-background": "var(--background-secondary-alt)",
		"--server-icon-active": "var(--brand-primary)",
		"--channel-sidebar-background": "var(--background-secondary)",
		"--member-list-background": "var(--background-secondary)",
		"--user-panel-background": "var(--background-secondary-alt)",
		"--user-area-divider-color": "var(--border-color)",
		"--mention-background": "var(--brand-tint)",
		"--menu-danger-text": "var(--status-danger)",
		"--button-outline-border": "1px solid var(--border-color-hover)",
		"--button-outline-active-border": "1px solid var(--border-color-focus)",
		"--button-danger-outline-border": "1px solid var(--status-danger)",
		"--button-danger-outline-active-border": "1px solid var(--status-danger)",
		"--text-selection": "color-mix(in srgb, var(--brand-primary-foreground) 28%, transparent)",
		"--bg-code": "var(--background-secondary-alt)",
		"--bg-code-block": "var(--background-tertiary)",
		"--code-inline-bg": "var(--background-secondary-alt)",
		"--code-block-bg": "var(--background-tertiary)",
		"--code-block-border": "var(--border-color)",
		"--guild-banner-gradient": "var(--background-tertiary)",
		"--text-on-danger": "#FFFFFF",
		"--text-on-success": "#FFFFFF",
		"--text-on-light": "#29231E",
		"--profile-banner-background": "var(--background-secondary-alt)",
		"--profile-card-border": "var(--border-color)",
		"--voice-placeholder-background": "#1B1A19"
	},
	"coal": {
		"--background-primary": "#0B0B0B",
		"--background-secondary": "#101010",
		"--background-secondary-alt": "#181614",
		"--background-secondary-lighter": "#201E1C",
		"--background-tertiary": "#050505",
		"--background-textarea": "#201E1C",
		"--background-channel-header": "#0B0B0B",
		"--background-header-primary": "#181614",
		"--background-header-primary-hover": "#35302B",
		"--background-header-secondary": "#181614",
		"--background-floating": "#201E1C",
		"--guild-list-foreground": "#101010",
		"--background-modifier-hover": "#35302B",
		"--background-modifier-selected": "#45301E",
		"--background-modifier-accent": "var(--background-modifier-hover)",
		"--background-modifier-accent-focus": "#FFAD63",
		"--text-primary": "#F5F1ED",
		"--text-chat": "#F5F1ED",
		"--text-secondary": "#C8BAB0",
		"--text-tertiary": "#B5A79C",
		"--text-tertiary-muted": "#A99B90",
		"--text-tertiary-secondary": "#A99B90",
		"--text-primary-muted": "#C8BAB0",
		"--text-chat-muted": "#B5A79C",
		"--brand-primary": "#FFAD63",
		"--brand-secondary": "#F6A05B",
		"--brand-primary-light": "#FFD1A7",
		"--brand-primary-foreground": "#FFAD63",
		"--brand-primary-fill": "#231407",
		"--brand-primary-light-fill": "#231407",
		"--brand-primary-shade": "#D58943",
		"--brand-tint": "#45301E",
		"--brand-tint-hover": "#563A23",
		"--brand-tint-border": "#C8894D",
		"--border-color": "#443D36",
		"--border-color-hover": "#867464",
		"--status-online": "#66D5A0",
		"--status-idle": "#E6C15A",
		"--status-dnd": "#FF9B9B",
		"--status-offline": "#A99B90",
		"--status-danger": "#FF9B9B",
		"--accent-info": "#8DCBF0",
		"--accent-purple": "#C6ABF0",
		"--button-danger-fill": "#B93048",
		"--button-danger-active-fill": "#9E263B",
		"--button-danger-text": "#FFFFFF",
		"--button-danger-outline-text": "#FF9B9B",
		"--button-danger-outline-active-fill": "#512830",
		"--panel-control-bg": "#201E1C",
		"--panel-control-border": "#61544A",
		"--panel-control-divider": "#443D36",
		"--panel-control-highlight": "#443D36",
		"--control-button-danger-hover-bg": "#512830",
		"--scrollbar-thumb-bg": "#78685A",
		"--scrollbar-thumb-bg-hover": "#A99B90",
		"--scrollbar-track-bg": "#151515",
		"--switch-track-inactive": "var(--border-color-hover)",
		"--switch-thumb": "#F5F1ED",
		"--switch-thumb-checked-icon": "var(--brand-primary)",
		"--switch-thumb-unchecked-icon": "#252321",
		"--button-inverted-fill": "#F5F1ED",
		"--button-inverted-text": "#1B1A19",
		"--text-on-dark": "#F5F1ED",
		"--brand-primary-pressed": "var(--brand-secondary)",
		"--text-on-brand-primary": "var(--brand-primary-fill)",
		"--text-on-brand-primary-light": "var(--brand-primary-light-fill)",
		"--text-on-brand-tint": "var(--brand-primary-foreground)",
		"--text-link": "var(--brand-primary-foreground)",
		"--border-color-focus": "var(--brand-primary-foreground)",
		"--focus-primary": "var(--brand-primary-foreground)",
		"--text-warning": "var(--status-idle)",
		"--text-danger": "var(--status-danger)",
		"--text-positive": "var(--status-online)",
		"--status-warning": "var(--status-idle)",
		"--accent-primary": "var(--brand-primary)",
		"--accent-success": "var(--status-online)",
		"--accent-warning": "var(--status-idle)",
		"--accent-danger": "var(--status-danger)",
		"--button-primary-fill": "var(--brand-primary)",
		"--button-primary-active-fill": "var(--brand-primary-pressed)",
		"--button-primary-text": "var(--text-on-brand-primary)",
		"--button-secondary-fill": "var(--background-secondary-alt)",
		"--button-secondary-active-fill": "var(--background-modifier-hover)",
		"--button-secondary-text": "var(--text-primary)",
		"--button-secondary-active-text": "var(--text-primary)",
		"--button-ghost-text": "var(--text-secondary)",
		"--button-outline-text": "var(--text-primary)",
		"--button-outline-active-fill": "var(--background-modifier-hover)",
		"--control-button-normal-bg": "var(--background-secondary-alt)",
		"--control-button-normal-text": "var(--text-secondary)",
		"--control-button-hover-bg": "var(--background-modifier-hover)",
		"--control-button-hover-text": "var(--text-primary)",
		"--control-button-active-bg": "var(--brand-tint)",
		"--control-button-active-text": "var(--text-on-brand-tint)",
		"--control-button-danger-text": "var(--status-danger)",
		"--interactive-normal": "var(--text-secondary)",
		"--interactive-hover": "var(--text-primary)",
		"--interactive-active": "var(--text-primary)",
		"--interactive-muted": "var(--text-tertiary-muted)",
		"--markup-mention-text": "var(--brand-primary-foreground)",
		"--markup-mention-fill": "var(--brand-tint)",
		"--markup-mention-border": "var(--brand-tint-border)",
		"--markup-interactive-hover-text": "var(--brand-primary-foreground)",
		"--markup-interactive-hover-fill": "var(--brand-tint-hover)",
		"--markup-jump-link-text": "var(--brand-primary-foreground)",
		"--markup-jump-link-fill": "var(--brand-tint)",
		"--markup-jump-link-hover-fill": "var(--brand-tint-hover)",
		"--alert-note-color": "var(--accent-info)",
		"--alert-tip-color": "var(--status-online)",
		"--alert-important-color": "var(--accent-purple)",
		"--alert-warning-color": "var(--status-idle)",
		"--alert-caution-color": "var(--status-danger)",
		"--bg-primary": "var(--background-primary)",
		"--bg-secondary": "var(--background-secondary)",
		"--bg-tertiary": "var(--background-tertiary)",
		"--bg-hover": "var(--background-modifier-hover)",
		"--bg-active": "var(--background-modifier-selected)",
		"--bg-table-header": "var(--background-tertiary)",
		"--bg-table-row-odd": "var(--background-primary)",
		"--bg-table-row-even": "var(--background-secondary)",
		"--surface-interactive-hover-bg": "var(--background-modifier-hover)",
		"--surface-interactive-selected-bg": "var(--background-modifier-selected)",
		"--surface-interactive-selected-color": "var(--text-primary)",
		"--embed-background": "var(--background-secondary)",
		"--embed-border": "var(--border-color)",
		"--chat-background": "var(--background-primary)",
		"--chat-input-background": "var(--background-textarea)",
		"--server-sidebar-background": "var(--background-tertiary)",
		"--server-icon-background": "var(--background-secondary-alt)",
		"--server-icon-active": "var(--brand-primary)",
		"--channel-sidebar-background": "var(--background-secondary)",
		"--member-list-background": "var(--background-secondary)",
		"--user-panel-background": "var(--background-secondary-alt)",
		"--user-area-divider-color": "var(--border-color)",
		"--mention-background": "var(--brand-tint)",
		"--menu-danger-text": "var(--status-danger)",
		"--button-outline-border": "1px solid var(--border-color-hover)",
		"--button-outline-active-border": "1px solid var(--border-color-focus)",
		"--button-danger-outline-border": "1px solid var(--status-danger)",
		"--button-danger-outline-active-border": "1px solid var(--status-danger)",
		"--text-selection": "color-mix(in srgb, var(--brand-primary-foreground) 28%, transparent)",
		"--bg-code": "var(--background-secondary-alt)",
		"--bg-code-block": "var(--background-tertiary)",
		"--code-inline-bg": "var(--background-secondary-alt)",
		"--code-block-bg": "var(--background-tertiary)",
		"--code-block-border": "var(--border-color)",
		"--guild-banner-gradient": "var(--background-tertiary)",
		"--text-on-danger": "#231407",
		"--text-on-success": "#231407",
		"--text-on-light": "#29231E",
		"--profile-banner-background": "var(--background-secondary-alt)",
		"--profile-card-border": "var(--border-color)",
		"--voice-placeholder-background": "#1B1A19"
	}
};

export const RACING_THEME_TONES: Readonly<Record<string, Readonly<Record<string, readonly [number, number, number]>>>> = {
	"dark": {
		"--background-primary": [
			30.0,
			3.846154,
			10.196078
		],
		"--background-secondary": [
			0.0,
			0.0,
			8.235294
		],
		"--background-secondary-alt": [
			30.0,
			6.666667,
			11.764706
		],
		"--background-secondary-lighter": [
			30.0,
			5.714286,
			13.72549
		],
		"--background-tertiary": [
			0.0,
			0.0,
			6.27451
		],
		"--background-textarea": [
			30.0,
			5.714286,
			13.72549
		],
		"--background-channel-header": [
			30.0,
			3.846154,
			10.196078
		],
		"--background-header-primary": [
			30.0,
			6.666667,
			11.764706
		],
		"--background-header-primary-hover": [
			30.0,
			10.416667,
			18.823529
		],
		"--background-header-secondary": [
			30.0,
			6.666667,
			11.764706
		],
		"--background-floating": [
			30.0,
			5.714286,
			13.72549
		],
		"--guild-list-foreground": [
			0.0,
			0.0,
			8.235294
		],
		"--background-modifier-hover": [
			30.0,
			10.416667,
			18.823529
		],
		"--background-modifier-selected": [
			27.692308,
			39.393939,
			19.411765
		],
		"--background-modifier-accent-focus": [
			28.461538,
			100.0,
			69.411765
		],
		"--text-primary": [
			30.0,
			28.571429,
			94.509804
		],
		"--text-chat": [
			30.0,
			28.571429,
			94.509804
		],
		"--text-secondary": [
			25.0,
			17.910448,
			73.72549
		],
		"--text-tertiary": [
			26.4,
			14.450867,
			66.078431
		],
		"--text-tertiary-muted": [
			26.4,
			12.690355,
			61.372549
		],
		"--text-tertiary-secondary": [
			26.4,
			12.690355,
			61.372549
		],
		"--text-primary-muted": [
			25.0,
			17.910448,
			73.72549
		],
		"--text-chat-muted": [
			26.4,
			14.450867,
			66.078431
		],
		"--brand-primary": [
			28.461538,
			100.0,
			69.411765
		],
		"--brand-secondary": [
			26.709677,
			89.595376,
			66.078431
		],
		"--brand-primary-light": [
			28.636364,
			100.0,
			82.745098
		],
		"--brand-primary-foreground": [
			28.461538,
			100.0,
			69.411765
		],
		"--brand-primary-fill": [
			27.857143,
			66.666667,
			8.235294
		],
		"--brand-primary-light-fill": [
			27.857143,
			66.666667,
			8.235294
		],
		"--brand-primary-shade": [
			28.767123,
			63.478261,
			54.901961
		],
		"--brand-tint": [
			27.692308,
			39.393939,
			19.411765
		],
		"--brand-tint-hover": [
			27.058824,
			42.14876,
			23.72549
		],
		"--brand-tint-border": [
			29.268293,
			52.7897,
			54.313725
		],
		"--border-color": [
			30.0,
			11.47541,
			23.921569
		],
		"--border-color-hover": [
			28.235294,
			14.529915,
			45.882353
		],
		"--status-online": [
			151.351351,
			56.923077,
			61.764706
		],
		"--status-idle": [
			44.142857,
			73.684211,
			62.745098
		],
		"--status-dnd": [
			0.0,
			100.0,
			80.392157
		],
		"--status-offline": [
			26.4,
			12.690355,
			61.372549
		],
		"--status-danger": [
			0.0,
			100.0,
			80.392157
		],
		"--accent-info": [
			202.424242,
			76.744186,
			74.705882
		],
		"--accent-purple": [
			263.478261,
			69.69697,
			80.588235
		],
		"--button-danger-fill": [
			349.489051,
			58.798283,
			45.686275
		],
		"--button-danger-active-fill": [
			349.5,
			61.22449,
			38.431373
		],
		"--button-danger-text": [
			0.0,
			0.0,
			100.0
		],
		"--button-danger-outline-text": [
			0.0,
			100.0,
			80.392157
		],
		"--button-danger-outline-active-fill": [
			348.292683,
			33.884298,
			23.72549
		],
		"--panel-control-bg": [
			30.0,
			6.666667,
			11.764706
		],
		"--panel-control-border": [
			26.086957,
			13.450292,
			33.529412
		],
		"--panel-control-divider": [
			30.0,
			11.47541,
			23.921569
		],
		"--panel-control-highlight": [
			30.0,
			11.47541,
			23.921569
		],
		"--control-button-danger-hover-bg": [
			348.292683,
			33.884298,
			23.72549
		],
		"--scrollbar-thumb-bg": [
			28.0,
			14.285714,
			41.176471
		],
		"--scrollbar-thumb-bg-hover": [
			26.4,
			12.690355,
			61.372549
		],
		"--scrollbar-track-bg": [
			0.0,
			0.0,
			8.235294
		],
		"--switch-thumb": [
			30.0,
			28.571429,
			94.509804
		],
		"--switch-thumb-unchecked-icon": [
			30.0,
			5.714286,
			13.72549
		],
		"--button-inverted-fill": [
			30.0,
			28.571429,
			94.509804
		],
		"--button-inverted-text": [
			30.0,
			3.846154,
			10.196078
		],
		"--text-on-dark": [
			30.0,
			28.571429,
			94.509804
		],
		"--text-on-danger": [
			27.857143,
			66.666667,
			8.235294
		],
		"--text-on-success": [
			27.857143,
			66.666667,
			8.235294
		],
		"--text-on-light": [
			27.272727,
			15.492958,
			13.921569
		],
		"--voice-placeholder-background": [
			30.0,
			3.846154,
			10.196078
		]
	},
	"light": {
		"--background-primary": [
			20.0,
			100.0,
			99.411765
		],
		"--background-secondary": [
			30.0,
			25.0,
			93.72549
		],
		"--background-secondary-alt": [
			27.692308,
			23.636364,
			89.215686
		],
		"--background-secondary-lighter": [
			30.0,
			36.363636,
			95.686275
		],
		"--background-tertiary": [
			28.0,
			24.590164,
			88.039216
		],
		"--background-textarea": [
			30.0,
			25.0,
			93.72549
		],
		"--background-channel-header": [
			20.0,
			100.0,
			99.411765
		],
		"--background-header-primary": [
			30.0,
			25.0,
			93.72549
		],
		"--background-header-primary-hover": [
			28.235294,
			25.373134,
			86.862745
		],
		"--background-header-secondary": [
			30.0,
			25.0,
			93.72549
		],
		"--background-floating": [
			20.0,
			100.0,
			99.411765
		],
		"--guild-list-foreground": [
			28.0,
			24.590164,
			88.039216
		],
		"--background-modifier-hover": [
			27.692308,
			23.636364,
			89.215686
		],
		"--background-modifier-selected": [
			29.333333,
			71.428571,
			87.647059
		],
		"--background-modifier-accent-focus": [
			24.0,
			82.352941,
			33.333333
		],
		"--text-primary": [
			27.272727,
			15.492958,
			13.921569
		],
		"--text-chat": [
			27.272727,
			15.492958,
			13.921569
		],
		"--text-secondary": [
			27.5,
			16.0,
			29.411765
		],
		"--text-tertiary": [
			27.857143,
			15.217391,
			36.078431
		],
		"--text-tertiary-muted": [
			27.857143,
			15.217391,
			36.078431
		],
		"--text-tertiary-secondary": [
			27.857143,
			15.217391,
			36.078431
		],
		"--text-primary-muted": [
			27.5,
			16.0,
			29.411765
		],
		"--text-chat-muted": [
			27.857143,
			15.217391,
			36.078431
		],
		"--brand-primary": [
			24.0,
			82.352941,
			33.333333
		],
		"--brand-secondary": [
			23.898305,
			83.098592,
			27.843137
		],
		"--brand-primary-light": [
			23.898305,
			83.098592,
			27.843137
		],
		"--brand-primary-foreground": [
			24.0,
			82.352941,
			33.333333
		],
		"--brand-primary-fill": [
			0.0,
			0.0,
			100.0
		],
		"--brand-primary-light-fill": [
			0.0,
			0.0,
			100.0
		],
		"--brand-primary-shade": [
			22.826087,
			85.185185,
			21.176471
		],
		"--brand-tint": [
			29.333333,
			71.428571,
			87.647059
		],
		"--brand-tint-hover": [
			30.0,
			64.102564,
			84.705882
		],
		"--brand-tint-border": [
			24.461538,
			63.72549,
			40.0
		],
		"--border-color": [
			28.8,
			18.518519,
			73.529412
		],
		"--border-color-hover": [
			27.428571,
			13.944223,
			49.215686
		],
		"--status-online": [
			147.073171,
			53.947368,
			29.803922
		],
		"--status-idle": [
			44.237288,
			100.0,
			23.137255
		],
		"--status-dnd": [
			349.090909,
			61.682243,
			41.960784
		],
		"--status-offline": [
			27.857143,
			15.217391,
			36.078431
		],
		"--status-danger": [
			349.090909,
			61.682243,
			41.960784
		],
		"--accent-info": [
			204.117647,
			60.0,
			33.333333
		],
		"--accent-purple": [
			267.826087,
			30.131004,
			44.901961
		],
		"--button-danger-fill": [
			349.090909,
			61.682243,
			41.960784
		],
		"--button-danger-active-fill": [
			347.678571,
			63.636364,
			34.509804
		],
		"--button-danger-text": [
			0.0,
			0.0,
			100.0
		],
		"--button-danger-outline-text": [
			349.090909,
			61.682243,
			41.960784
		],
		"--button-danger-outline-active-fill": [
			350.0,
			66.666667,
			92.941176
		],
		"--panel-control-bg": [
			30.0,
			25.0,
			93.72549
		],
		"--panel-control-border": [
			27.857143,
			13.861386,
			60.392157
		],
		"--panel-control-divider": [
			28.8,
			18.518519,
			73.529412
		],
		"--panel-control-highlight": [
			20.0,
			100.0,
			99.411765
		],
		"--control-button-danger-hover-bg": [
			350.0,
			66.666667,
			92.941176
		],
		"--scrollbar-thumb-bg": [
			27.428571,
			13.944223,
			49.215686
		],
		"--scrollbar-thumb-bg-hover": [
			27.5,
			16.0,
			29.411765
		],
		"--scrollbar-track-bg": [
			30.0,
			25.0,
			93.72549
		],
		"--switch-thumb": [
			0.0,
			0.0,
			100.0
		],
		"--switch-thumb-unchecked-icon": [
			27.5,
			16.0,
			29.411765
		],
		"--button-inverted-fill": [
			27.272727,
			15.492958,
			13.921569
		],
		"--button-inverted-text": [
			20.0,
			100.0,
			99.411765
		],
		"--text-on-dark": [
			30.0,
			28.571429,
			94.509804
		],
		"--text-on-danger": [
			0.0,
			0.0,
			100.0
		],
		"--text-on-success": [
			0.0,
			0.0,
			100.0
		],
		"--text-on-light": [
			27.272727,
			15.492958,
			13.921569
		],
		"--voice-placeholder-background": [
			30.0,
			3.846154,
			10.196078
		]
	},
	"coal": {
		"--background-primary": [
			0.0,
			0.0,
			4.313725
		],
		"--background-secondary": [
			0.0,
			0.0,
			6.27451
		],
		"--background-secondary-alt": [
			30.0,
			9.090909,
			8.627451
		],
		"--background-secondary-lighter": [
			30.0,
			6.666667,
			11.764706
		],
		"--background-tertiary": [
			0.0,
			0.0,
			1.960784
		],
		"--background-textarea": [
			30.0,
			6.666667,
			11.764706
		],
		"--background-channel-header": [
			0.0,
			0.0,
			4.313725
		],
		"--background-header-primary": [
			30.0,
			9.090909,
			8.627451
		],
		"--background-header-primary-hover": [
			30.0,
			10.416667,
			18.823529
		],
		"--background-header-secondary": [
			30.0,
			9.090909,
			8.627451
		],
		"--background-floating": [
			30.0,
			6.666667,
			11.764706
		],
		"--guild-list-foreground": [
			0.0,
			0.0,
			6.27451
		],
		"--background-modifier-hover": [
			30.0,
			10.416667,
			18.823529
		],
		"--background-modifier-selected": [
			27.692308,
			39.393939,
			19.411765
		],
		"--background-modifier-accent-focus": [
			28.461538,
			100.0,
			69.411765
		],
		"--text-primary": [
			30.0,
			28.571429,
			94.509804
		],
		"--text-chat": [
			30.0,
			28.571429,
			94.509804
		],
		"--text-secondary": [
			25.0,
			17.910448,
			73.72549
		],
		"--text-tertiary": [
			26.4,
			14.450867,
			66.078431
		],
		"--text-tertiary-muted": [
			26.4,
			12.690355,
			61.372549
		],
		"--text-tertiary-secondary": [
			26.4,
			12.690355,
			61.372549
		],
		"--text-primary-muted": [
			25.0,
			17.910448,
			73.72549
		],
		"--text-chat-muted": [
			26.4,
			14.450867,
			66.078431
		],
		"--brand-primary": [
			28.461538,
			100.0,
			69.411765
		],
		"--brand-secondary": [
			26.709677,
			89.595376,
			66.078431
		],
		"--brand-primary-light": [
			28.636364,
			100.0,
			82.745098
		],
		"--brand-primary-foreground": [
			28.461538,
			100.0,
			69.411765
		],
		"--brand-primary-fill": [
			27.857143,
			66.666667,
			8.235294
		],
		"--brand-primary-light-fill": [
			27.857143,
			66.666667,
			8.235294
		],
		"--brand-primary-shade": [
			28.767123,
			63.478261,
			54.901961
		],
		"--brand-tint": [
			27.692308,
			39.393939,
			19.411765
		],
		"--brand-tint-hover": [
			27.058824,
			42.14876,
			23.72549
		],
		"--brand-tint-border": [
			29.268293,
			52.7897,
			54.313725
		],
		"--border-color": [
			30.0,
			11.47541,
			23.921569
		],
		"--border-color-hover": [
			28.235294,
			14.529915,
			45.882353
		],
		"--status-online": [
			151.351351,
			56.923077,
			61.764706
		],
		"--status-idle": [
			44.142857,
			73.684211,
			62.745098
		],
		"--status-dnd": [
			0.0,
			100.0,
			80.392157
		],
		"--status-offline": [
			26.4,
			12.690355,
			61.372549
		],
		"--status-danger": [
			0.0,
			100.0,
			80.392157
		],
		"--accent-info": [
			202.424242,
			76.744186,
			74.705882
		],
		"--accent-purple": [
			263.478261,
			69.69697,
			80.588235
		],
		"--button-danger-fill": [
			349.489051,
			58.798283,
			45.686275
		],
		"--button-danger-active-fill": [
			349.5,
			61.22449,
			38.431373
		],
		"--button-danger-text": [
			0.0,
			0.0,
			100.0
		],
		"--button-danger-outline-text": [
			0.0,
			100.0,
			80.392157
		],
		"--button-danger-outline-active-fill": [
			348.292683,
			33.884298,
			23.72549
		],
		"--panel-control-bg": [
			30.0,
			6.666667,
			11.764706
		],
		"--panel-control-border": [
			26.086957,
			13.450292,
			33.529412
		],
		"--panel-control-divider": [
			30.0,
			11.47541,
			23.921569
		],
		"--panel-control-highlight": [
			30.0,
			11.47541,
			23.921569
		],
		"--control-button-danger-hover-bg": [
			348.292683,
			33.884298,
			23.72549
		],
		"--scrollbar-thumb-bg": [
			28.0,
			14.285714,
			41.176471
		],
		"--scrollbar-thumb-bg-hover": [
			26.4,
			12.690355,
			61.372549
		],
		"--scrollbar-track-bg": [
			0.0,
			0.0,
			8.235294
		],
		"--switch-thumb": [
			30.0,
			28.571429,
			94.509804
		],
		"--switch-thumb-unchecked-icon": [
			30.0,
			5.714286,
			13.72549
		],
		"--button-inverted-fill": [
			30.0,
			28.571429,
			94.509804
		],
		"--button-inverted-text": [
			30.0,
			3.846154,
			10.196078
		],
		"--text-on-dark": [
			30.0,
			28.571429,
			94.509804
		],
		"--text-on-danger": [
			27.857143,
			66.666667,
			8.235294
		],
		"--text-on-success": [
			27.857143,
			66.666667,
			8.235294
		],
		"--text-on-light": [
			27.272727,
			15.492958,
			13.921569
		],
		"--voice-placeholder-background": [
			30.0,
			3.846154,
			10.196078
		]
	}
};
